import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Landing.css';
import forte_logo from '../../assets/forte_logo_white.svg';
import cognitoService from '../../services/cognitoService';
import PasswordInput from '../../components/common/PasswordInput';

const ForgotPassword = () => {
  const [step, setStep] = useState(1); // 1: request, 2: confirm
  const [username, setUsername] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleRequest = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      await cognitoService.forgotPassword(username);
      setStep(2);
    } catch (err) {
      setError(err.message || 'Failed to send code');
    }
    setIsLoading(false);
  };

  const handleConfirm = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      await cognitoService.confirmForgotPassword(username, code, newPassword);
      setSuccess(true);
      setTimeout(() => navigate('/'), 1500);
    } catch (err) {
      setError(err.message || 'Failed to reset password');
    }
    setIsLoading(false);
  };

  return (
    <div className={`landing-page${isLoading ? ' transitioning' : ''}`}>
      <div className="background-logos">
        <img src={forte_logo} alt="Forte Logo" className="bg-logo forte-logo" />
      </div>
      <div className="landing-container">
        <div className="landing-content">
          <h1 className="landing-title">Reset Password</h1>
          <p className="landing-subtitle">Forgot your password? Reset it here.</p>
          <div className="auth-section">
            {step === 1 ? (
              <form onSubmit={handleRequest} className="auth-form">
                <input
                  type="text"
                  placeholder="Username"
                  value={username}
                  onChange={e => setUsername(e.target.value)}
                  disabled={isLoading}
                  autoComplete="username"
                  required
                />
                {error && <div className="auth-error">{error}</div>}
                <button className="primary-button" type="submit" disabled={isLoading}>
                  {isLoading ? 'Sending...' : 'Send Reset Code'}
                </button>
              </form>
            ) : (
              <form onSubmit={handleConfirm} className="auth-form">
                <input
                  type="text"
                  placeholder="Confirmation Code"
                  value={code}
                  onChange={e => setCode(e.target.value)}
                  disabled={isLoading}
                  required
                />
                <PasswordInput
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  placeholder="New Password"
                  disabled={isLoading}
                  autoComplete="new-password"
                  required
                />
                {error && <div className="auth-error">{error}</div>}
                {success && <div className="auth-success">Password reset! Redirecting to login...</div>}
                <button className="primary-button" type="submit" disabled={isLoading}>
                  {isLoading ? 'Resetting...' : 'Reset Password'}
                </button>
              </form>
            )}
            <div className="auth-toggle">
              <button type="button" onClick={() => navigate('/')} disabled={isLoading} className="link-button">Back to Login</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword; 